import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Constants } from '@shared/models';
import { DocumentsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';

// Note:  1) Edit the document F:/ShuttleNomix/Docs/ReleaseNotes/ReleaseNotes.html.
//        2) Copy the html contents and paste into
//        3) Open the Backend | Settings | Docs | ReleaseNotes
//        4) Paste the html into the contents textarea and save.
//        5) Test the Release Notes page by opening the App and then go to About | Release Notes

@Component({
    'selector': 'app-releaseNotes',
    'templateUrl': './releaseNotes.page.html',
    'styleUrls': ['./releaseNotes.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]

})
export class ReleaseNotesPage extends ViewBasePage implements OnInit {
    public releases: any = [];
    public myHTML = {};

    constructor(private documentsService: DocumentsService, private domSanitizer: DomSanitizer, injector: Injector) {
        super(injector);
        super.setCurrentView(this.Constants.VIEW_RELEASE_NOTES);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.loadDocument();
    }

    public async loadDocument() {
        try {
            await this.uxHelperService.showSpinner('Loading data.');
            const metaData = this.documentsService.getDocumentMetaDataByViewName(Constants.VIEW_RELEASE_NOTES);
            const doc = await this.documentsService.getByUid(metaData.uid);

            // The doc file may have data.test = xxx.  By default this is considered to be
            // dangerous code and is removed.  Prevent the removal by bypassing this security.
            const trustedDoc = this.domSanitizer.bypassSecurityTrustHtml(doc.contents);
            this.myHTML = trustedDoc;
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            const msg = errorMessage || 'Release Notes document not found.';
            this.uxHelperService.showAlert('Error', msg);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }

    // public async loadFileFromFirebaseStorage() {
    //     await this.uxHelperService.showSpinner('Loading data.');

    //     try {
    //         const content: any = await this.firebazeStorageService.getMiscDocument(Constants.DOCUMENT_RELEASE_NOTES);
    //         // The releaseNotes.json file has a version number and a release date in it.
    //         // Consider those values to be there for just documentation.  To avoid any
    //         // confusion on the users part, always use the version number and release date
    //         // found in myConfig.
    //         // findAndReplace(content.issues, versionNumber, myConfig.APPLICATION_VERSION);
    //         // findAndReplace(content.issues, releaseDate,   myConfig.APPLICATION_RELEASE_DATE);
    //         const releases = JSON.parse(content);
    //         this.releases = releases;
    //         await this.uxHelperService.hideSpinner();
    //     } catch (err) {
    //         await this.uxHelperService.hideSpinner();
    //         // this.navCtrl.pop();
    //         const msg = err.message_ || 'Release Notes document not found.';
    //         this.uxHelperService.showAlert('Error', msg);
    //     }
    // }
}
